import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    score: 0,
    answer: null,
    showAnswer: false,
    correctAnswer: false,
    question: null,
  },
  mutations: {
    updateAnswer: (state, answer) => {
      state.answer = answer.value;
      state.correctAnswer = answer.isCorrect;
    },
    showAnswer: (state) => {
      state.showAnswer = true;
      if (state.correctAnswer === true) {
        state.score++;
      }
    },
    startAgain: (state) => {
      state.score = 0;
      state.answer = null;
      state.showAnswer = false;
      state.correctAnswer = false;
    },
    nextQuestion: (state) => {
      state.answer = null;
      state.showAnswer = false;
      state.correctAnswer = false;
      state.question = null;
    },
  },
  actions: {
    resetQuestion: (state) => {
      state.commit('nextQuestion', null);
    },
    resetScore: (state) => {
      state.commit('startAgain', null);
    },
  },
  getters: {
    getScore: (state) => {
      return state.score;
    },
    getAnswer: (state) => {
      return state.answer;
    },
    getShowAnswer: (state) => {
      return state.showAnswer;
    },
  },
});
